// source: type/tax_calculation_result.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.TaxCalculationResult', null, global);
goog.exportSymbol('proto.type.TaxCalculationResult.ResultType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.TaxCalculationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.TaxCalculationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.TaxCalculationResult.displayName = 'proto.type.TaxCalculationResult';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.TaxCalculationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.type.TaxCalculationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.TaxCalculationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxCalculationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resultType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TaxCalculationResult as accepted by the `fromObject` method.
 * @record
 */
proto.type.TaxCalculationResult.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.text;

  /** @type {?|undefined} */
  this.resultType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.TaxCalculationResult.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.TaxCalculationResult}
 */
proto.type.TaxCalculationResult.fromObject = function(obj) {
  var msg = new proto.type.TaxCalculationResult();
  obj.text != null && jspb.Message.setField(msg, 1, obj.text);
  obj.resultType != null && jspb.Message.setField(msg, 2, obj.resultType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.TaxCalculationResult}
 */
proto.type.TaxCalculationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.TaxCalculationResult;
  return proto.type.TaxCalculationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.TaxCalculationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.TaxCalculationResult}
 */
proto.type.TaxCalculationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = /** @type {!proto.type.TaxCalculationResult.ResultType} */ (reader.readEnum());
      msg.setResultType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.TaxCalculationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.TaxCalculationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.TaxCalculationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.TaxCalculationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResultType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.TaxCalculationResult.ResultType = {
  UNSPECIFIED: 0,
  TAXABLE_AMOUNT: 1,
  TAX_AMOUNT: 2
};

/**
 * optional string text = 1;
 * @return {string}
 */
proto.type.TaxCalculationResult.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.TaxCalculationResult} returns this
 */
proto.type.TaxCalculationResult.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ResultType result_type = 2;
 * @return {!proto.type.TaxCalculationResult.ResultType}
 */
proto.type.TaxCalculationResult.prototype.getResultType = function() {
  return /** @type {!proto.type.TaxCalculationResult.ResultType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.type.TaxCalculationResult.ResultType} value
 * @return {!proto.type.TaxCalculationResult} returns this
 */
proto.type.TaxCalculationResult.prototype.setResultType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.type);
